<script setup>
import { watch } from 'vue';
import { useRouter } from 'vue-router';
import GenericEvent from '@/components/events/GenericEvent.vue';

const props = defineProps({
  event: Object,
  isLoading: Boolean,
});

const router = useRouter();

watch(() => props.isLoading, (val) => {
  if (!props.event && val === false) {
    router.push({ path: '/' });
  }
});
</script>

<template>
  <generic-event :event="event"></generic-event>
</template>
